import React, { lazy, Suspense } from 'react'
import getMovieTitle from '../functions/getMovieTitle'
import SliderBasicTitle from './SliderBasicTitle'

const SliderBasicItemMovie = lazy(() => import('./SliderBasicItemMovie'))

const SliderBasicItemLoadingContent = ({
    title,
    styles
}) => (
    <div className='slide-item-content-wrapper'>
        <div className="slider-item-text">
            <SliderBasicTitle title={title}/>
        </div>

        <div className="slider-item-link" style={styles}></div>
    </div>
)

const SliderBasicItemLoadingContentArthouse = ({
    title,
    styles
}) => (
    <div className='slide-item-content-wrapper'>
        <div className='top-section'>
            <SliderBasicTitle title={title}/>
        </div>

        <div className='bottom-section'>
            <div>
                <div className="slider-item-link" style={styles}></div>
            </div>
        </div>
    </div>
)


const SliderBasicItemLoadingInner = ({
    className,
    title,
    isArthouse
}) => {

    const el = document.getElementsByClassName("slick-dots " + className)
    let marginBottom = 40

    if(el[0]) {
        marginBottom = el[0].clientHeight + 10
    }

    const styles = {
        marginBottom: marginBottom
    }


    return (
        <div className={"image-wrapper " + className}>
            <div className="image background-visuals-container"></div>

            <div className='gradient'>
                <div className="slider-basic-item-content">
                    {isArthouse ? (
                        <SliderBasicItemLoadingContentArthouse
                            title={title}
                            styles={styles}
                        />
                    ) : (
                        <SliderBasicItemLoadingContent
                            title={title}
                            styles={styles}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}



export const SliderBasicItemLoading = ({
    className,
    title,
    hasScrollLink,
    isArthouse,
}) => {
    if(hasScrollLink) {
        return (
            <div className="slick-slide-inner">
                <SliderBasicItemLoadingInner
                    className={className}
                    title={title}
                    isArthouse={isArthouse}
                />
            </div>
        )
    } else {
        return (
            <SliderBasicItemLoadingInner
                className={className}
                title={title}
                isArthouse={isArthouse}
            />
        )
    }
}

const SliderBasicItemMovieLazy = (props) => {
    const itemTitle = props.adData && props.adData.title ? props.adData.title : getMovieTitle(props.movieData)

    return (
        <Suspense fallback={<SliderBasicItemLoading 
            className={props.className} 
            title={itemTitle} 
            isArthouse={props.theme === 'Arthouse'}
            hasScrollLink={props.adData && props.adData.link && props.adData.link.url}
        />}>
            <SliderBasicItemMovie
                {...props}
            />
        </Suspense>
    )

}

export default SliderBasicItemMovieLazy